import { Group } from "@mantine/core";
import { Fragment } from "react";
import type { ChatTask } from "@/sdk/agent/chat";
import { formatPartnerName } from "@/shared-types";
import { PartnerBadge } from "../CustomerSections";
import type { ChatListProps } from "./FlatChatList";
import { FlatChatList } from "./FlatChatList";

export function GroupedChatList({ chats, ...rest }: ChatListProps) {
    const avatarsByPartner = chats.reduce<Record<string, ChatTask[]>>((accumulator, chat) => {
        // biome-ignore lint/suspicious/noAssignInExpressions: fix later
        (accumulator[chat.partner] ??= []).push(chat);
        return accumulator;
    }, {});

    const groupedAvatars = Object.entries(avatarsByPartner).map(([partner, partnerChats]) => {
        const formattedPartnerName = formatPartnerName(partner);
        return (
            <Fragment key={`chat-partner-group-${partner}`}>
                <Group p="md">
                    {/* TODO: awaiting new designs to build new component here */}
                    <PartnerBadge partner={formattedPartnerName} variant="outline" color="gray.6" />
                </Group>
                <FlatChatList chats={partnerChats} {...rest} />
            </Fragment>
        );
    });

    return groupedAvatars;
}
